<template>
  <div class="AnalysisContainer">
    <!-- 整体作答情况 start -->
    <div class="summary">
      <div class="content_title">
        <i class="icon icon-shu"></i>
        整体作答情况
      </div>
      <el-table :border="true" size="mini" header-row-class-name="tableHeader" :data="taskStatistics">
        <el-table-column prop="QuestionNum" label="题目总数"></el-table-column>
        <el-table-column label="总人数">
          <template>
            {{ studentList.length }}
          </template>
        </el-table-column>
        <el-table-column prop="StudentNum" label="完成人数"></el-table-column>
        <el-table-column prop="RightAcc" label="正确率"></el-table-column>
        <template v-if="task.IsScore">
          <el-table-column prop="AvgStudentResult" label="平均成绩">
            <template slot-scope="scope">
              {{ scope.row.AvgStudentResult != undefined ? scope.row.AvgStudentResult.toFixed(1) : "" }}
            </template>
          </el-table-column>
          <el-table-column prop="MaxStudentResult" label="最高成绩"></el-table-column>
          <el-table-column prop="MinStudentResult" label="最低成绩"></el-table-column>
        </template>
        <el-table-column label="平均用时">
          <template slot-scope="scope">
            {{ secondToDate(scope.row.AvgStudentTime) }}
          </template>
        </el-table-column>
        <el-table-column label="最快用时">
          <template slot-scope="scope">
            {{ secondToDate(scope.row.FastStudentTime) }}
          </template>
        </el-table-column>
        <el-table-column label="最慢用时">
          <template slot-scope="scope">
            {{ secondToDate(scope.row.SlowStudentTime) }}
          </template>
        </el-table-column>
        <el-table-column label="正确率人数">
          <el-table-column prop="ANum" label="[100%-90%]" min-width="100"></el-table-column>
          <el-table-column prop="BNum" label="(90%-80%]" min-width="100"></el-table-column>
          <el-table-column prop="CNum" label="(80%-60%]" min-width="100"></el-table-column>
          <el-table-column prop="DNum" label="(60%-0%]" min-width="100"></el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <!-- 整体作答情况 end -->
    <!-- 各题作答情况 start -->
    <div task_questions>
      <div class="content_title">
        <i class="icon icon-shu"></i>
        各题作答情况
      </div>
      <div class="questionsAnalysis">
        <div id="taskContainer" class="questionsLeft">
          <div class="question_page">
            <button
              type="button"
              class="layui-btn"
              v-for="page in pageCount"
              :key="page"
              :class="{ active: page == pageNum }"
              @click="pageChange(page)"
            >
              {{ page }}
            </button>
          </div>
          <div class="questions">
            <div
              id="questionsContainer"
              class="task_page"
              :style="{
                width:
                  (task.SizeType == 1 && task.pages && task.pages.length >= pageNum
                    ? task.pages[pageNum - 1].PageWidth
                    : task.TrueWidth) + 'mm',
                height:
                  (task.SizeType == 1 && task.pages && task.pages.length >= pageNum
                    ? task.pages[pageNum - 1].PageHeight
                    : task.TrueHeight) + 'mm',
                padding: task.PaddingWidth + 'mm',
                boxSizing: 'border-box',
              }"
            >
              <template v-if="task.pages && task.pages.length >= pageNum">
                <div v-if="task.Online == 1" id="taskPageOnline" class="w-e-text-container">
                  <div
                    class="page-question-item w-e-text"
                    v-for="(question, index) in task.pages[pageNum - 1].questions"
                    :key="'question' + question.ID"
                    :id="'question' + question.ID"
                    :class="{ active: activeQuestion.ID == question.ID }"
                  >
                    <div v-html="question.QuestionStem" @click="questionChange(index)"></div>
                    <button
                      v-if="question.TaskRelPushQuestions && question.TaskRelPushQuestions.length > 0"
                      :title="'再推了' + question.TaskRelPushQuestions.length + '道推题'"
                      class="push-count"
                      :style="{top:(question.RegionY - Math.floor(homework.PaddingWidth / 210 * 793.69 * 100)/100 + 10) + 'px'}"
                      @click="openPushed(question, pageNum - 1, index)"
                    >
                      {{ question.TaskRelPushQuestions.length }}
                    </button>
                  </div>
                </div>
                <div v-else-if="task.Online == 2 || task.Online == 3" id="taskPageBook">
                  <img
                    :src="task.pages[pageNum - 1].PageImg"
                    :style="{
                      maxWidth: (task.SizeType != 1 ? task.TrueWidth : task.pages[pageNum - 1].PageWidth) + 'mm',
                      maxHeight: (task.SizeType != 1 ? task.TrueHeight : task.pages[pageNum - 1].PageHeight) + 'mm',
                    }"
                  />
                  <div
                    class="pageQuestion"
                    v-for="(question, index) in task.pages[pageNum - 1].questions"
                    :key="'question' + question.ID"
                    :id="'question' + question.ID"
                    :class="{ active: activeQuestion.ID == question.ID }"
                    :style="{
                      top: question.RegionY + 'px',
                      left: question.RegionX + 'px',
                      width: question.RegionW + 'px',
                      height: question.RegionH + 'px',
                    }"
                    @click="questionChange(index)"
                  >
                    <button
                      v-if="question.TaskRelPushQuestions && question.TaskRelPushQuestions.length > 0"
                      :title="'再推了' + question.TaskRelPushQuestions.length + '道推题'"
                      class="push-count"
                      @click="openPushed(question, pageNum - 1, index)"
                    >
                      {{ question.TaskRelPushQuestions.length }}
                    </button>
                  </div>
                </div>
                <div v-else-if="task.Online == 4" class="question-page">
                  <p class="title-container" v-if="pageNum == 1">
                    <span class="paper-name">{{ task.TaskName }}</span>
                  </p>
                  <p class="chapter" v-if="pageNum == 1">
                    <span>{{ task.TeachingPlanTitle }}</span>
                  </p>
                  <div class="">
                    <div
                      v-for="(question, index) in task.pages[pageNum - 1].questions"
                      :id="'question' + question.ID"
                      :key="'question' + question.ID"
                      class="question-item"
                      :style="{
                        width: task.TrueWidth - task.PaddingWidth * 2 + 'mm',
                      }"
                    >
                      <p class="question-type" v-if="countShowType(pageNum - 1, index)">
                        {{ question.QuestionTypeName }}
                        <span v-show="task.IsScore">（共{{ countTypeTotalScore(question.QuestionType) }}分）</span>
                      </p>

                      <div
                        class="question-content"
                        :class="{ active: activeQuestion.ID === question.ID }"
                        @click="questionChange(index)"
                      >
                        <p class="question-no">
                          <span>{{ countType(pageNum - 1, index) }}、</span>
                          <span v-show="task.IsScore">（本题{{ question.Score }}分）</span>
                        </p>
                        <template v-if="question.QuestionStem">
                          <div v-html="question.QuestionStem"></div>
                        </template>
                        <el-image
                          v-else
                          :src="question.QuestionStemImage"
                          :style="{
                            width: question.RegionW + 'px',
                            height: question.RegionH + 'px',
                            display: 'block',
                          }"
                        ></el-image>
                        <div :style="'height: ' + question.AdditionalAnswerArea + 'px'"></div>
                        <button
                          v-if="question.TaskRelPushQuestions && question.TaskRelPushQuestions.length > 0"
                          :title="'再推了' + question.TaskRelPushQuestions.length + '道推题'"
                          class="push-count"
                          @click="openPushed(question, pageNum - 1, index)"
                        >
                          {{ question.TaskRelPushQuestions.length }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div id="rightBox">
          <h4>各题正确率</h4>
          <ul class="questions_analyse">
            <li
              v-for="(queAnalyse, queIndex) in questionsAnalyseData"
              :key="'queAnalyse' + queIndex"
              @click="questionChange2(queIndex)"
              :class="{ active: activeIndex == queIndex }"
            >
              <p class="question-num">{{ queIndex + 1 }}</p>
              <p
                class="correct"
                :class="{ danger: queAnalyse.QuestionTable && queAnalyse.QuestionTable.CorrectRate <= 60 }"
              >
                {{ queAnalyse.QuestionTable ? queAnalyse.QuestionTable.CorrectRate : "-" }}%
              </p>
            </li>
          </ul>
          <h4>
            第{{ activeIndex + 1 }}题（{{ activeQuestion.QuestionTypeName }}）
            <strong v-if="activeQuestion !== null && activeQuestion.QuestionType < 4">
              答案：{{ activeQuestion.Answer }}
            </strong>
          </h4>
          <div id="answerGroupChart" v-show="activeQuestion != null && activeQuestion.QuestionType < 4"></div>
          <div class="analysisTable">
            <table v-if="questionsAnalyseData[activeIndex]">
              <tr>
                <th>题目</th>
                <th>答题人数</th>
                <th>答对人数</th>
                <th>正确率</th>
                <th>操作</th>
              </tr>
              <tr class="active">
                <td>原题{{ activeIndex + 1 }}</td>
                <td>{{ questionsAnalyseData[activeIndex].QuestionTable.TotalNum }}</td>
                <td>{{ questionsAnalyseData[activeIndex].QuestionTable.RightNum }}</td>
                <td
                  :class="{
                    danger: questionsAnalyseData[activeIndex].QuestionTable.CorrectRate <= 60,
                  }"
                >
                  {{ questionsAnalyseData[activeIndex].QuestionTable.CorrectRate }} %
                </td>
                <td><a href="javascript:void(0)" @click="openDetail(-1)">解析</a></td>
              </tr>
              <tr
                v-for="(pushQue, pushIndex) in questionsAnalyseData[activeIndex].QuestionTable.PushQuestion"
                :key="'pushIndex' + pushIndex"
              >
                <td>推题{{ pushIndex + 1 }}</td>
                <td>{{ pushQue.TotalNum }}</td>
                <td>{{ pushQue.RightNum }}</td>
                <td :class="{ danger: pushQue.CorrectRate <= 60 }">{{ pushQue.CorrectRate }} %</td>
                <td><a href="javascript:void(0)" @click="openDetail(pushIndex)">解析</a></td>
              </tr>
            </table>
          </div>
          <el-table
            height="692px"
            style="margin-top: 20px; margin-bottom: 10px; overflow: auto"
            header-row-class-name="tableHeader"
            ref="StudentAnswerTable"
            :border="true"
            :stripe="true"
            :highlight-current-row="true"
            cell-class-name="cell"
            :data="studentAnswers"
          >
            <el-table-column
              prop="StudentName"
              sortable
              width="90"
              :filters="studentNameFilter"
              :filter-method="filterStudentName"
              :sort-method="SortStudentName"
              label="学生"
            ></el-table-column>
            <el-table-column
              v-if="activeQuestion != null && activeQuestion.QuestionType < 4"
              prop="StudentAnswer"
              sortable
              :filters="answerFilter"
              :filter-method="filterAnswer"
              :formatter="answerFormatter"
              label="答案"
            ></el-table-column>
            <el-table-column
              prop="StudentRight"
              sortable
              :filters="correctFilter"
              :filter-method="filterCorrect"
              label="结果"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 各题作答情况 end -->

    <!-- 各学生作答情况 start -->
    <div class="answerDetail">
      <div class="content_title">
        <i class="icon icon-shu"></i>
        各学生作答情况
      </div>
      <el-table :border="true" :data="studentList" header-row-class-name="tableHeader">
        <el-table-column prop="StudentName" label="学生姓名"></el-table-column>
        <el-table-column prop="TotalQuestionNum" label="答题总数"></el-table-column>
        <el-table-column label="答题用时">
          <template slot-scope="scope">
            {{ secondToDate(scope.row.SumDuration) }}
          </template>
        </el-table-column>
        <el-table-column prop="CorrectAnswersNum" label="正确题数"></el-table-column>
        <el-table-column prop="WrongAnswersNum" label="错误题数"></el-table-column>
        <el-table-column prop="CorrectRate" :label="task.IsScore ? '成绩' : '正确率'"></el-table-column>
        <!-- <el-table-column prop="WrongRate" label="错误率">
        </el-table-column> -->
        <el-table-column type="index" label="排名"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="answerDetail(scope)" type="text">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 各学生作答情况 end -->

    <!-- 题目&推题详情dialog start -->
    <el-dialog
      title="提示"
      :visible.sync="pushDetailDialog"
      width="1000px"
      :append-to-body="true"
      top="10vh"
      v-dialogDrag
      :close-on-click-modal="false"
      style="overflow: hidden"
    >
      
      <div class="work-question">
        <span class="q-type source">原题</span>
        <question-detail
          :question="activeQuestion"
          :analysisData="questionsAnalyseData[activeIndex] ? questionsAnalyseData[activeIndex].QuestionTable : null"
          :borderColor="'#00a2e8'"
        ></question-detail>
      </div>
      <div class="push-questions">
        <ul v-if="activeQuestion.TaskRelPushQuestions && activeQuestion.TaskRelPushQuestions.length > 0">
          <li v-for="(pushQue, pushIndex) in activeQuestion.TaskRelPushQuestions" :key="'push' + pushIndex">
            <span class="q-type push">推题{{ pushIndex + 1 }}</span>
            <question-push-detail
              :type="'pushList'"
              :question="pushQue"
              :analysisData="
                questionsAnalyseData[activeIndex]
                  ? questionsAnalyseData[activeIndex].QuestionTable.PushQuestion[pushIndex]
                  : null
              "
              :borderColor="'#ffc90e'"
            ></question-push-detail>
          </li>
        </ul>
        <div v-else>未推题练习</div>
      </div>
    </el-dialog>
    <!-- 题目&推题详情dialog end -->
    <!-- 题目or推题解析dialog start -->
    <el-dialog
      title="试题详情"
      :visible.sync="quesDetailDialog"
      width="1000px"
      :append-to-body="true"
      top="5vh"
      v-dialogDrag
      :close-on-click-modal="false"
      style="overflow: hidden"
    >
      <div class="detail">
        <question-push-detail
          v-if="activePushIndex >= 0"
          :type="'pushDetail'"
          :question="activeQuestion.TaskRelPushQuestions[activePushIndex]"
          :analysisData="
            questionsAnalyseData[activeIndex]
              ? questionsAnalyseData[activeIndex].QuestionTable.PushQuestion[activePushIndex]
              : null
          "
          :borderColor="'#ffc90e'"
          :openDetail="true"
        ></question-push-detail>
        <question-detail
          v-else
          :question="activeQuestion"
          :analysisData="questionsAnalyseData[activeIndex] ? questionsAnalyseData[activeIndex].QuestionTable : null"
          :borderColor="'#00a2e8'"
          :openDetail="true"
        ></question-detail>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EchartTheam from "./../../assets/js/echartTheam.json";
// import * as Echart from "echarts";
// 按需引入
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import { 
  BarChart, // 柱状图
  PieChart, // 饼图
} from 'echarts/charts';
// 引入标题，提示框，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TooltipComponent, // 鼠标悬停或其他操作时显示提示信息
  GridComponent, // 非常常用，几乎所有基于直角坐标系的图表（如柱状图、折线图等）都需要这些组件
  LegendComponent, // 展示图表的各类别信息

} from 'echarts/components';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步(选一个即可)
import { CanvasRenderer } from 'echarts/renderers';

// 注册必须的组件
echarts.use([
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BarChart,
  PieChart, 
  CanvasRenderer
]);

import QuestionBankList from "./QuestionBankList.vue";
import QuestionDetail from "./QuestionDetail.vue";
import QuestionPushDetail from "./QuestionPushDetail.vue";

let colorList = [
  "#658FFF",
  "#b04aff",
  "#3AB679",
  "#eed538",
  "#a379a8",
  "#0ae617",
  "#EE8344",
  "#EE75C0",
  "#2BA8B6",
  "#7466EE",
  "#62B682",
  "#15EEBF",
  "#FF740F",
  "#1009EE",
  "#EE05B7",
  "#EE0312",
];
let rightBox;
let answerGroupChart;
let myChart = null;

export default {
  name: "TaskAnalysis",
  components: { QuestionBankList, QuestionDetail, QuestionPushDetail },
  props: {
    taskID: {
      type: Number,
    },
    lessonID: {
      type: Number,
    },
    deviceWidth: {
      type: Number,
    },
    deviceHeight: {
      type: Number,
    },
    taskComShow: {
      type: Boolean,
    },
  },
  data() {
    return {
      pageNum: 1,
      pageCount: 0,
      count: 0,
      activeIndex: -1, //当前页选中题的index
      activeQuestion: {
        RegionX: 0,
        RegionY: 0,
        RegionW: 0,
        RegionH: 0,
        ID: 0,
        TaskListID: 0,
        PageID: 0,
        PageNum: 1,
        QuestionNum: 0,
        QuestionType: 1,
        QuestionTypeName: "",
        QuestionStem: "",
        QuestionStemImage: "",
        Answer: "",
        Explain: "",
        isOnline: 0,
        DifficultLvl: null,
        Score: null,
        KnowledgePoints: null,
        Sort: null,
        TaskForQuestionPoints: [], //关联的知识点
        TaskPrePushQuestions: [], //预设的推题
        TaskRelPushQuestions: [], //真正的推题
      },
      task: {
        pages: [
          {
            questions: [],
            PageID: 0,
            PageNum: 1,
            PageImg: "",
            PageWidth: 0,
            PageHeight: 0,
          },
        ],
        TeachingPlanID: 0,
        TeachingPlanTitle: "",
        questionCount: 0,
        TaskListID: 0,
        TaskRelTeachingPlanID: 0,
        TaskName: "",
        School: null,
        Author: null,
        IsCloud: -1,
        Online: 1,
        IsScore: true,
        SizeType: 2,
        TrueWidth: 210,
        TrueHeight: 297,
        PaddingWidth: 10,
      },
      taskQuestions: [],
      taskStatistics: [
        {
          IsScore: 0,
          QuestionNum: 0,
          StudentNum: 0,
          RightAcc: "0%",
          AvgStudentResult: 0,
          MaxStudentResult: 0,
          MinStudentResult: 0,
          AvgStudentTime: 0,
          FastStudentTime: 0,
          SlowStudentTime: 0,
          ANum: 0,
          BNum: 0,
          CNum: 0,
          DNum: 0,
        },
      ],
      questionStatistics: {
        TotalNum: 0,
        RightNum: 0,
        ErrorNum: 0,
        CorrectRate: "0%",
      },

      studentList: [],
      // 作答结果 {0:'错误',1:'正确',-1:"未批"}
      xArr: [], //['A', 'B', 'C']
      yArr: [], //[1, 2, 4]
      option: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          label: {
            show: true,
            formatter: "{a} <br/>{b} : {c} ({d}%)",
          },
        },
        grid: {
          left: "6%",
          right: "50px",
          bottom: "6%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            name: "选项",
            nameTextStyle: {
              fontSize: 14,
            },
            data: [], //['A', 'B', 'C']
            axisTick: {
              alignWithLabel: true,
            },
            /* axisLine: {
              lineStyle: {
                color: '#fff'
              }
            } */
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "人数",
            nameTextStyle: {
              fontSize: 14,
            },
            /* data: [10, 30, 50, 70, 90, 100], */
            /* axisLine: {
              lineStyle: {
                color: '#fff'
              }
            } */
          },
        ],
        series: [
          {
            name: "所占人数",
            type: "bar",
            barWidth: "50%",
            data: [], //[1, 2, 4]
            label: {
              normal: {
                show: true,
                position: "top",
                textStyle: {
                  fontFamily: "微软雅黑",
                  fontSize: 14,
                },
              },
            },
            itemStyle: {
              //通常情况下：
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: function(params) {
                  return colorList[params.dataIndex];
                },
              },
              //鼠标悬停时：
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      /* 各题分析数据正确率 */
      questionsAnalyseData: [
        {
          //一题的正确率、答题人数及答对人数统计数据
          QuestionTable: {
            QuestionNum: 1, //题号
            QuestionID: 5690, //作业原题的id
            TotalNum: 1, //答题人数
            RightNum: 0, //答对人数
            ErrorNum: 1, //答错人数
            CorrectRate: 0, //正确率
            Answer: "B", //正确答案
            StudentRight: [], //答对的学生姓名
            StudentWrong: [], //答错的学生姓名
            PushQuestion: [
              //本题的推题的答题统计数据
              {
                QuestionNum: 1, //题号
                QuestionID: 5690, //作业原题的id
                PushID: 1, //推题的id
                TotalNum: 1, //答题人数
                RightNum: 0, //答对人数
                ErrorNum: 1, //答错人数
                CorrectRate: 0, //正确率
                Answer: "B", //正确答案
                StudentRight: [], //答对的学生姓名
                StudentWrong: [], //答错的学生姓名
              },
            ],
          },
          //一题的答题结果的柱状图统计数据
          EchartData: {
            Item: ["A"],
            Num: [1],
          },
          //一题的各学生题目答题结果数据
          StudentForQuestionTable: [
            {
              StudentID: "4ae317f0-c30d-4be9-9b0c-619fd1712537",
              StudentName: "张程",
              StudentAnswer: "B",
              StudentRight: "错误",
            },
          ],
        },
      ],
      studentAnswers: [
        /* {
                    StudentName: '张程',
                    StudentAnswer: "B",
                    StudentRight: "错误"
                  } */
      ],
      // 作答结果 {0:'错误',1:'正确',-1:"未批"}
      studentNameFilter: [],
      answerFilter: [],
      correctFilter: [
        {
          text: "错误",
          value: "错误",
        },
        {
          text: "正确",
          value: "正确",
        },
        {
          text: "未批",
          value: "未批",
        },
        {
          text: "",
          value: "",
        },
      ],
      pushDetailDialog: false, //推题详情dialog开关
      quesDetailDialog: false, //试题解析详情dialog开关
      activePushIndex: -1, //选中的要查看解析详情的推题的序号
    };
  },
  created() {
    // window.myTaskData = this;
   echarts.registerTheme("roma", EchartTheam);

  },
  mounted() {
    //获取任务单详情

    //获取任务单整体统计分析

    //获取学生列表
    rightBox = document.getElementById("rightBox");
    answerGroupChart = document.getElementById("answerGroupChart");
    myChart = echarts.init(answerGroupChart, "roma");
  },

  methods: {
    initTask() {
      this.pageNum = 1;
      this.pageCount = 0;
      this.count = 0;
      this.activeIndex = -1;
      this.activeQuestion = {};
      this.task = {
        pages: [],
        TeachingPlanID: 0,
        TeachingPlanTitle: "",
        questionCount: 0,
        TaskListID: 0,
        TaskRelTeachingPlanID: 0,
        TaskName: "",
        School: null,
        Author: null,
        IsCloud: -1,
        Online: 1,
        IsScore: true,
        SizeType: 2,
        TrueWidth: 210,
        TrueHeight: 297,
        PaddingWidth: 10,
      };
      this.taskQuestions = [];
      this.taskStatistics = [];
      this.setTaskPageScale();
      this.resizeCanvas();
    },
    initQuestionStatistics() {
      this.xArr = [];
      this.yArr = [];
      this.resizeCanvas();
      this.questionsAnalyseData = [];
      this.studentAnswers = [];
      this.studentNameFilter = [];
      this.answerFilter = [];
    },
    questionIndex(pageIndex, index) {
      let count = 0;
      for (let i = 0; i < pageIndex; i++) {
        count += this.task.pages[i].questions.length;
      }
      return count + index;
    },
    questionChange(index) {
      this.activeIndex = this.questionIndex(this.pageNum - 1, index);
      //watch里activeIndex变化执行
    },

    /**
     * 作业题目切换
     * @param index //题目在整份作业中的序号
     */
    questionChange2(index) {
      this.activeIndex = index;
      this.activeQuestion = this.taskQuestions[index];
      this.pageNum = this.activeQuestion.PageNum;
      if (this.activeQuestion !== null) {
        this.xArr = this.questionsAnalyseData[this.activeIndex].EchartData.Item;
        this.yArr = this.questionsAnalyseData[this.activeIndex].EchartData.Num;
        this.resizeCanvas();
        this.studentAnswers = this.questionsAnalyseData[this.activeIndex].StudentForQuestionTable;
        //更新过滤项
        if (this.studentAnswers !== null && this.studentAnswers.length > 0) {
          for (let i = 0, len = this.studentAnswers.length; i < len; i++) {
            let stuAnswer = this.studentAnswers[i];
            this.studentNameFilter.push({
              text: stuAnswer.StudentName,
              value: stuAnswer.StudentName,
            });
            let answerExist = false;
            let answerText = "";
            let answerValue = stuAnswer.StudentAnswer;
            switch (this.activeQuestion.QuestionType) {
              case 1:
              case 2:
                answerText = stuAnswer.StudentAnswer;
                break;
              case 3:
                answerText = stuAnswer.StudentAnswer === "T" ? "对" : "错";
                break;
            }
            for (let j = 0, len = this.answerFilter.length; j < len; j++) {
              let answerItem = this.answerFilter[j];
              if (answerItem.value === answerValue) {
                answerExist = true;
                break;
              }
            }
            if (!answerExist) {
              this.answerFilter.push({
                text: answerText,
                value: answerValue,
              });
            }
          }
        }
      }
      let column = this.$refs.StudentAnswerTable.columns[1];
      column.filteredValue = [];
      this.$refs.StudentAnswerTable.store.commit("filterChange", {
        column,
        values: column.filteredValue,
        silent: true,
      });
    },
    pageChange(page) {
      this.pageNum = page;
      if (this.taskQuestions.length > 0 && this.task.pages[this.pageNum - 1].questions.length > 0) {
        this.questionChange(0);
      }
    },
    /**
     * 判断是否显示题型
     * @param pageIndex
     * @param questionIndex
     * @returns {boolean}
     */
    countShowType(pageIndex, questionIndex) {
      if (pageIndex == 0) {
        if (questionIndex == 0) {
          return true;
        } else {
          return (
            this.task.pages[pageIndex].questions[questionIndex - 1].QuestionType !=
            this.task.pages[pageIndex].questions[questionIndex].QuestionType
          );
        }
      } else {
        if (questionIndex == 0) {
          return (
            this.task.pages[pageIndex - 1].questions[this.task.pages[pageIndex - 1].questions.length - 1]
              .QuestionType != this.task.pages[pageIndex].questions[questionIndex].QuestionType
          );
        } else {
          return (
            this.task.pages[pageIndex].questions[questionIndex - 1].QuestionType !=
            this.task.pages[pageIndex].questions[questionIndex].QuestionType
          );
        }
      }
    },
    /**
     * 计算题型总分
     */
    countTypeTotalScore(questionType) {
      let totalScore = 0;
      for (let page of this.task.pages) {
        for (let que of page.questions) {
          if (que.QuestionType == questionType) {
            totalScore += que.Score;
          }
        }
      }
      return totalScore;
    },
    /**
     * 计算题号
     * @param pageIndex 页index
     * @param questionIndex 题的index
     * @returns {*|number}
     */
    countType(pageIndex, questionIndex) {
      let count = 0;
      if (pageIndex > 0) {
        for (let i = 0; i < pageIndex; i++) {
          count += this.task.pages[i].questions.length;
        }
      }
      count = count + questionIndex + 1;
      return count;
    },
    //表格过滤
    // 1.学生姓名过滤
    filterStudentName(value, row, column) {
      return value === row.StudentName;
    },
    //2,学生答案过滤,预留.
    filterAnswer(value, row, column) {
      return value === row.StudentAnswer;
    },
    // 3.作答结果过滤
    filterCorrect(value, row, column) {
      return value == row.StudentRight;
    },
    answerFormatter(row, column) {
      switch (row.StudentAnswer) {
        case "t":
        case "T":
          return "对";
        case "f":
        case "F":
          return "错";
        case "":
          return "未作答";
        default:
          return row.StudentAnswer;
      }
    },
    SortStudentName(a, b) {
      // console.log('a:' + JSON.stringify(a) + ',b:' + JSON.stringify(b));
      return a.StudentName.localeCompare(b.StudentName, "zh-CN");
    },
    answerDetail(scope) {
      // console.log(scope.row);
      let params = {
        lessonID: this.lessonID,
        studentID: scope.row.StudentID,
        taskID: this.taskID,
      };
      // console.log(params);
      let routeData = this.$router.resolve({
        name: "StudentTaskDetail",
        query: params,
      });
      window.open(routeData.href, "_blank");
    },
    getTaskDetail() {
      this.axios.get(window.url + "GetTaskListPageQuesiton?TaskRelTeachingPlanID=" + this.taskID + "&LessonID=" + this.lessonID).then((res) => {
        var result = res.data;
        this.returnCode(result.result, result.message);
        if (200 == result.result) {
          //正常数据
          let taskData = result.data;
          this.task = taskData;
          if (this.task.SizeType == 0) {
            this.task.SizeType == 2;
            this.task.TrueWidth = 210;
            this.task.TrueHeight = 297;
          }
          if (this.task.Online == 1 || this.task.Online == 4) {
            //在线出题,智能组卷
            if (!this.task.PaddingWidth || this.task.PaddingWidth == 0) {
              this.task.PaddingWidth = 10;
            }
          }
          this.setTaskPageScale();

          this.pageNum = 1;
          this.pageCount = taskData.pages.length;
          this.count = taskData.questionCount;
          for (let taskPage of taskData.pages) {
            this.taskQuestions = this.taskQuestions.concat(taskPage.questions);
          }
          this.activeIndex = 0;
          this.activeQuestion = this.taskQuestions[0];
        }
      });
    },
    getTaskStatistics() {
      this.axios
        .get(window.url + "GetTaskWholeAnswerCollect", {
          params: {
            taskRelTeachingPlanID: this.taskID,
            lessonID: this.lessonID,
          },
        })
        .then((res) => {
          var result = res.data;
          this.returnCode(result.result, result.message);
          if (200 == result.result) {
            //正常数据
            let data = result.data;
            if (data != null) {
              this.taskStatistics = [];
              this.taskStatistics.push(data);
            } else {
              this.taskStatistics = [];
            }
          }
        });
    },
    getQuestionStatistics() {
      this.initQuestionStatistics();
      this.axios
        .get(window.url + "GetTaskForQuestionCollect", {
          params: {
            TaskRelTeachingPlanID: this.taskID,
            lessonID: this.lessonID,
          },
        })
        .then((res) => {
          var result = res.data;
          this.returnCode(result.result, result.message);
          if (200 == result.result) {
            //正常数据
            let data = result.data;
            if (data != null && data.length > 0) {
              this.questionsAnalyseData = data;
              if (this.activeIndex == -1) {
                this.activeIndex = 0;
              }
              this.xArr = this.questionsAnalyseData[this.activeIndex].EchartData.Item;
              this.yArr = this.questionsAnalyseData[this.activeIndex].EchartData.Num;
              this.resizeCanvas();
              this.studentAnswers = this.questionsAnalyseData[this.activeIndex].StudentForQuestionTable;
              //更新过滤项
              if (this.studentAnswers != null && this.studentAnswers.length > 0) {
                for (let i = 0, len = this.studentAnswers.length; i < len; i++) {
                  let stuAnswer = this.studentAnswers[i];
                  this.studentNameFilter.push({
                    text: stuAnswer.StudentName,
                    value: stuAnswer.StudentName,
                  });
                  let answerExist = false;
                  let answerText = "";
                  let answerValue = stuAnswer.StudentAnswer;
                  if (stuAnswer.StudentAnswer.length > 0) {
                    switch (this.activeQuestion.QuestionType) {
                      case 1:
                      case 2:
                        answerText = stuAnswer.StudentAnswer;
                        break;
                      case 3:
                        answerText = stuAnswer.StudentAnswer == "T" ? "对" : "错";
                        break;
                    }
                  }

                  for (let j = 0, len = this.answerFilter.length; j < len; j++) {
                    let answerItem = this.answerFilter[j];
                    if (answerItem.value == answerValue) {
                      answerExist = true;
                      break;
                    }
                  }
                  if (!answerExist) {
                    this.answerFilter.push({
                      text: answerText,
                      value: answerValue,
                    });
                  }
                  this.answerFilter.sort((a, b) => {
                    return a.text - b.text;
                  });
                }
              }
            } else {
              this.initQuestionStatistics();
            }
          }
        });
    },
    getStudentList() {
      this.axios
        .get(window.url + "GetTaskListAnswersSummay", {
          params: {
            taskRelTeachingPlanID: this.taskID,
            LessonID: this.lessonID,
          },
        })
        .then((res) => {
          var result = res.data;
          this.returnCode(result.result, result.message);
          if (200 == result.result) {
            //正常数据
            let data = result.data;
            if (data != null) {
              this.studentList = data;
            } else {
              this.studentList = [];
            }
          }
        });
    },
    // 返回值调用
    returnCode(code, msg) {
      var that = this;
      if (code != 200) {
        if (code == 201) {
          this.$router.push({
            name: "Login",
          });
        }
        that.$message.error(msg);
        return;
      }
    },
    setTaskPageScale() {
      //任务单真正的宽高，单位毫米mm
      //作业真正的宽高，单位毫米mm
      let pageW =
        this.task.TrueWidth > 0
          ? this.task.TrueWidth
          : this.task.pages.length > 0 && this.task.pages[this.pageNum - 1].PageWidth > 0
          ? this.task.pages[this.pageNum - 1].PageWidth
          : 210;
      let pageH =
        this.task.TrueHeight > 0
          ? this.task.TrueHeight
          : this.task.pages.length > 0 && this.task.pages[this.pageNum - 1].PageHeight > 0
          ? this.task.pages[this.pageNum - 1].PageHeight
          : 297;
      // 毫米mm换算成像素px
      let w = Math.round((pageW / 210) * 793.69 * 100) / 100;
      let h = Math.round((pageH / 210) * 793.69 * 100) / 100;
      let PageWidth = (this.deviceWidth - 320 - 20 * 2) * 0.65 - 10;
      let MarginTop = (((PageWidth - w) / 2) * pageH) / pageW;
      let MarginLeft = (PageWidth - w) / 2;
      let pageScale = PageWidth / w;
      let questionsDivHeight = h * pageScale;
      document.getElementsByClassName("questionsAnalysis")[0].style.cssText =
        "height: " + (questionsDivHeight + 60) + "px;";
      document.querySelectorAll("#taskContainer>.questions")[0].style.cssText = "height: " + questionsDivHeight + "px;";
      let questionContainer = document.getElementById("questionsContainer");
      if (questionContainer != null) {
        questionContainer.style.cssText += "margin: " + MarginTop + "px " + MarginLeft + "px 0px !important; ";
        questionContainer.style.cssText +=
          "transform:scale(" +
          pageScale +
          ");-webkit-transform:scale(" +
          pageScale +
          ");-moz-transform:scale(" +
          pageScale +
          ");";
      }
    },
    /**
     * 图表重绘
     */
    resizeCanvas() {
      if (rightBox) {
        let width = rightBox.offsetWidth * 0.933;
        answerGroupChart.setAttribute("style", `width:${width}px;height:240px`);
        this.option.xAxis[0].data = this.xArr;
        this.option.series[0].data = this.yArr;
        myChart.resize();
        myChart.setOption(this.option);
        let that = this;
        myChart.on("click", (params) => {
          // console.log(params);
          let column = this.$refs.StudentAnswerTable.columns[1];
          column.filteredValue = [params.name];
          this.$refs.StudentAnswerTable.store.commit("filterChange", {
            column,
            values: column.filteredValue,
            silent: true,
          });
        });
      }
    },

    openPushed(question, pageIndex, questionIndex) {
      console.log(pageIndex,questionIndex);
      console.log(question);
      this.activeIndex = this.questionIndex(pageIndex, questionIndex);
      console.log(this.activeIndex);
      console.log(this.activeQuestion);
      this.activeQuestion = question;
      this.pushDetailDialog = true;
    },
    openDetail(pushIndex) {
      this.activePushIndex = pushIndex;
      this.quesDetailDialog = true;
    },
  },

  watch: {
    taskID(newID, oldID) {
      this.initTask();
      this.initQuestionStatistics();
      if (this.taskID > 0) {
        this.getTaskDetail();
        this.getTaskStatistics();
        this.studentList = [];
        this.getStudentList();
        this.getQuestionStatistics();
      }
    },
    lessonID(newID, oldID) {
      this.initQuestionStatistics();
      if (this.taskID > 0) {
        this.getTaskDetail();
        this.getTaskStatistics();
        this.studentList = [];
        this.getStudentList();
        this.initQuestionStatistics();
        this.getQuestionStatistics();
      }
    },
    activeIndex(newIndex, oldIndex) {
      console.log(this.taskQuestions);
      console.log(this.activeIndex);
      if (newIndex > -1 && this.task.pages.length > 0) {
        this.activeQuestion = this.taskQuestions[this.activeIndex];
        if (
          this.activeQuestion != null &&
          this.questionsAnalyseData &&
          this.questionsAnalyseData.length > this.activeIndex
        ) {
          this.xArr = this.questionsAnalyseData[this.activeIndex].EchartData.Item;
          this.yArr = this.questionsAnalyseData[this.activeIndex].EchartData.Num;
          this.resizeCanvas();
          this.studentAnswers = this.questionsAnalyseData[this.activeIndex].StudentForQuestionTable;
          //更新过滤项
          if (this.studentAnswers !== null && this.studentAnswers.length > 0) {
            for (let i = 0, len = this.studentAnswers.length; i < len; i++) {
              let stuAnswer = this.studentAnswers[i];
              this.studentNameFilter.push({
                text: stuAnswer.StudentName,
                value: stuAnswer.StudentName,
              });
              let answerExist = false;
              let answerText = "";
              let answerValue = stuAnswer.StudentAnswer;
              switch (this.activeQuestion.QuestionType) {
                case 1:
                case 2:
                  answerText = stuAnswer.StudentAnswer;
                  break;
                case 3:
                  answerText = stuAnswer.StudentAnswer === "T" ? "对" : "错";
                  break;
              }
              for (let j = 0, len = this.answerFilter.length; j < len; j++) {
                let answerItem = this.answerFilter[j];
                if (answerItem.value === answerValue) {
                  answerExist = true;
                  break;
                }
              }
              if (!answerExist) {
                this.answerFilter.push({
                  text: answerText,
                  value: answerValue,
                });
              }
            }
          }
        }
        let column = this.$refs.StudentAnswerTable.columns[1];
        column.filteredValue = [];
        this.$refs.StudentAnswerTable.store.commit("filterChange", {
          column,
          values: column.filteredValue,
          silent: true,
        });
      }
    },
    deviceWidth(nValue, oValue) {
      let that = this;
      setTimeout(function() {
        that.setTaskPageScale();
        that.resizeCanvas();
      }, 300);
    },
    taskComShow(nValue, oValue) {
      this.resizeCanvas();
    },
  },
};
</script>

<style scoped lang="less">
.AnalysisContainer {
  box-sizing: border-box;

  /deep/ .tableHeader {
    background: #f6f6f6;

    th {
      background: #f6f6f6;
      color: #2c3e50;
    }
  }

  .content_title {
    background-color: #ffffff;
    margin-bottom: 10px;
    text-align: left;
    padding-left: 30px;
    font-size: 16px;
    font-weight: 600;
    /*position: fixed;*/
    position: relative;

    .icon-shu {
      position: absolute;
      left: 0px;
      font-size: 24px;
      background: #59bf85;
      border-radius: 2px;
      width: 5px;
      height: 16px;
      margin: 0px 5px;
      display: inline-block;
    }
  }

  //整体作答情部
  .summary {
    margin-top: 20px;
    margin-bottom: 20px;

    /deep/ .el-table td {
      padding: 8px 0;
    }
  }

  //各题作答情况
  .questionsAnalysis {
    display: flex;
    position: relative;
  }

  #taskContainer {
    position: absolute;
    right: 35%;
    left: 5px;
    top: 0;
    text-align: left;

    .question_page {
      display: flex;
      justify-content: center;
      padding: 5px;

      button {
        margin: 5px 5px;
        padding: 0 5px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 3px;
        color: #1e87f0;
        font-size: 18px;
        background: transparent;
        border: 1px solid #9e9e9e;

        &.active {
          background-color: #1e9fff;
          color: #fff;
          border: none;
        }
      }
    }

    .questions {
      overflow: hidden;
      height: 93%;
      -moz-box-shadow: 0 0.06rem 0.1rem 0 #c2c2c2, 0 0.06rem 0.2rem 0 #666;
      -webkit-box-shadow: 0 0.06rem 0.1rem 0 #c2c2c2, 0 0.06rem 0.2rem 0 #666;
      box-shadow: 0 0.06rem 0.1rem 0 #c2c2c2, 0 0.06rem 0.2rem 0 #666;
      /* transform:scale(1.2); */
      /* -webkit-transform:scale(1.2); */
      /*兼容-webkit-引擎浏览器*/
      /* -moz-transform:scale(1.2); */
      /*兼容-moz-引擎浏览器*/

      .task_page {
        position: relative;
        font-size: 10.5pt !important;
        color: #000000;
        font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB";
        word-break: normal;
        width: 210mm;
        height: 297mm;
        padding: 10mm;
        margin: 0 auto 0.5rem;
        box-sizing: border-box;
        background: #fff;

        .push-count {
          position: absolute;
          right: -24px;
          top: 10px;
          background: #fd694c;
          color: #fff;
          width: 24px;
          height: 24px;
          border: 0;
          line-height: 24px;
          text-align: center;
          font-size: 14px;
          font-family: sans-serif;
          cursor: pointer;
        }

        .w-e-text-container {
          font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif;
					overflow: visible;

          /deep/ a {
            color: rgb(0, 0, 238);
          }

          /deep/ p {
            font-size: 10.5pt !important;
						word-break: normal;
            strong {
              font-weight: 600;
            }
          }
        }

        #taskPageOnline {
          .w-e-text.page-question-item {
            // position: relative;
            overflow: hidden;
            // border: 1px solid transparent;
            color: #000000;
            padding: 0;
						word-break: normal;
          }

          .page-question-item.active {
            border: 1px solid #ff4e00;
          }
        }

        #taskPageBook {
          position: absolute;
          top: 0mm;
          bottom: 0mm;
          left: 0mm;
          right: 0mm;

          img {
            position: absolute;
            max-width: 210mm;
            max-height: 297mm;
          }

          .pageQuestion.active {
            border-color: #ff4e00;
          }

          .pageQuestion {
            box-sizing: border-box;
            position: absolute;
            z-index: 3;
            border: 1px solid #e4e4e4;
          }
        }

        .question-page {
          background: white;

          p {
            text-align: center;
            height: 30px;
            line-height: 30px;
            font-size: 11px;
            margin: 0;

            &.title-container {
              font-size: 20px;
            }
          }

          .question-item.active {
            border: 1px solid #ff4e00;
          }

          .question-item {
            width: 180mm;
            overflow: visible;

            p.question-type {
              height: 30px;
              line-height: 30px;
              font-size: 18px;
              text-align: left;
              color: #333;
            }

            p.question-no {
              height: 25px;
              line-height: 25px;
              text-align: left;
              font-size: 15px;
              display: flex;
            }

            div.question-content {
              position: relative;
              border: none;
							word-break: normal;

              &.active {
                border: 1px solid #ff4e00;
              }

              div.answer,
              div.explain {
                display: flex;

                span {
                  color: #409eff;
                  font-size: 15px;
                  margin-right: 10px;
                  width: 70px;
                }
              }
            }
          }
        }
      }
    }

    .questions::-webkit-scrollbar {
      width: 0;
    }
  }

  #rightBox {
    width: 33.5%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    padding-left: 1.5%;
    display: flex;
    flex-direction: column;

    h4 {
      position: relative;
      font-weight: 600;
      text-align: left;
      strong {
        position: absolute;
        right: 0;
        color: #03a4e9;
      }
    }
    ul.questions_analyse {
      display: flex;
      margin: 10px 0 15px;
      align-items: center;
      justify-content: left;
      flex-wrap: wrap;
      border-left: 1px solid #cecece;
      border-top: 1px solid #cecece;
      li {
        position: relative;
        box-sizing: border-box;
        width: 20%;
        padding: 10px;
        background-color: #fff;
        border-right: 1px solid #cecece;
        border-bottom: 1px solid #cecece;
        text-align: center;
        font-weight: 600;
        font-size: 15px;
        color: #333;
        &.active {
          background-color: #fbf9ec;
        }
				p {
					line-height: normal;
				}

        .correct {
          font-size: 16px;
          &.danger {
            color: #f0486f;
          }
        }
        a {
          position: absolute;
          right: 0;
          top: 0;
          padding: 2px;
        }
      }
    }
    .flex-container {
      display: -webkit-flex;
      display: flex;
      width: 100%;
      max-width: 500px;
      height: 250px;
      background-color: lightgrey;
    }

    .flex-item {
      width: 90px;
      height: 90px;
      margin: 10px;
    }

    #answerGroupChart {
      height: 280px;
      margin-top: 30px;
    }

    .analysisTable {
      width: 100%;
      margin-top: 20px;

      table {
        width: 100%;
        border-collapse: collapse;

        tr {
          td {
            padding: 7px 0;
            width: 80px;
            border: 1px solid #ebeef5;

            &.th {
              background: #f6f6f6;
              color: #2c3e50;
              width: 100px;
            }
          }
        }
      }
    }
  }

  //各学生作答情况
  .answerDetail {
    margin-top: 30px;

    /deep/ .el-table td {
      padding: 5px 0;
    }
  }

  /deep/ .el-table td {
    padding: 0;
  }

  .popImg {
    position: fixed;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.7);

    left: 0;
    right: 0;
    bottom: 0;
    top: 0;

    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      max-height: 100%;
      max-width: 100%;
    }
  }
}

/deep/.searchDialog {
  border-radius: 10px;
  max-height: 80vh;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .el-dialog__header {
    padding: 10px 20px 10px;
    border-radius: 10px 10px 0 0;
    background: #2489f6 !important;
    color: #fff;
    .el-dialog__headerbtn {
      top: 10px;
      font-size: 20px;
      .el-dialog__close {
        color: #fff;
      }
    }
    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #fff;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #fff;
    }
    .el-checkbox__inner {
      background-color: transparent;
      border-color: #fff;
    }
    a.change-one {
      color: #fff;
      position: absolute;
      top: 12px;
      right: 100px;
      i {
        margin-right: 5px;
      }
    }
  }
  .el-dialog__body {
    overflow: auto;
    flex: 1;
    .searchIndex {
      display: flex;
      flex-direction: column;
      .query {
        margin: 15px 15px 5px 15px;
        border: 1px solid #b1afaf;
        border-radius: 10px;
        .analysis {
          margin-left: 20px;
          p {
            margin-bottom: 15px;
          }
        }
        .footer {
          display: flex;
          justify-content: space-between;
          border-radius: 10px;
          background: #eee;
          .info {
            line-height: 35px;
            margin-left: 10px;
            span {
              margin-left: 10px;
            }
          }
          .operate {
            margin-top: 3px;
            margin-right: 5%;
          }
        }
      }
    }
  }
}
.push-questions,
.work-question {
  position: relative;
  li {
    position: relative;
  }
  .q-type {
    position: absolute;
    width: 30px;
    padding: 10px;
    color: #fffcfd;
    &.push {
      background: #ffc90e;
    }
    &.source {
      background: #00a2e8;
    }
  }
}
</style>

<style>
.w-e-text img {
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/TaskAnalysis.vue